import type { ScalarGuideElement } from '@/types'
import { attributesMathSchema, type AttributesMath } from './attributes'
import { validate } from '@/helpers/validate'
export type { AttributesMath } from './attributes'
import { guideMathHtml } from '@/elements/math/components'

export const scalarMath: ScalarGuideElement<AttributesMath, 'scalar-math'> = {
  name: 'scalar-math',
  tagName: 'scalar-math',
  tiptapName: 'math',
  attributeTransform: (content, attributes) => {
    return validate(attributesMathSchema, {
      equation: attributes.equation ? attributes.equation.toString() : content,
      caption: attributes.caption ? attributes.caption.toString() : '',
    })
  },
  render: async (props) => guideMathHtml(props),
}

export { ScalarMathVue } from './components'
